import {
    computed,
    DestroyRef,
    Directive,
    inject,
    input,
    type OnInit,
} from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MatCheckbox } from '@angular/material/checkbox';
import { distinctUntilChanged } from 'rxjs';

export type CheckboxSize = 'md' | 'sm';
export type CheckboxDensity = 'comfortable' | 'compact';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'mat-checkbox[qpx]',
    host: {
        '[attr.id]': 'id()',
        '[class]': 'className()',
    },
})
export class QpxCheckbox implements OnInit {
    private readonly checkbox = inject(MatCheckbox, { host: true });
    private readonly destroyRef = inject(DestroyRef);

    public readonly id = input.required<string>();
    public readonly size = input<CheckboxSize>('md');
    public readonly density = input<CheckboxDensity>('comfortable');
    public readonly variant = input<'square' | 'round'>('square');
    public readonly ripple = input<boolean>(false);
    private readonly ripple$ = toObservable(this.ripple);

    public readonly context = input<'primary' | 'warn' | 'accent'>('primary');
    private readonly context$ = toObservable(this.context);

    protected readonly className = computed(() => {
        const _classNames = [
            'qpx-checkbox',
            this.size(),
            `density-${this.density()}`,
            `mat-${this.context()}`,
        ];
        if (this.variant() === 'square') {
            _classNames.push('square');
        }
        return _classNames.join(' ');
    });

    ngOnInit(): void {
        this.ripple$
            .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
            .subscribe((value) => (this.checkbox.disableRipple = !value));

        this.context$
            .pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef))
            .subscribe((value) => (this.checkbox.color = value));
    }
}
